import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { Setor } from '../models/setor';
import { Turno } from '../models/turno';
import { Escala, EscalaPeriodo, SetorItensEscalaPeriodoColaborador } from '../models/escala';

@Injectable({
  providedIn: 'root'
})
export class ScaleInUseService {
  private courierSubject = new BehaviorSubject<EscalaPeriodo | null>(null);
  courier$ = this.courierSubject.asObservable();

  private escalaPai = new BehaviorSubject<Escala | null>(null);
  escalaPai$ = this.escalaPai.asObservable();

  private turnos = new BehaviorSubject<Turno[]>([]);
  turnos$ = this.turnos.asObservable();

  private setores = new BehaviorSubject<Setor[]>([]);
  setores$ = this.setores.asObservable();

  private setoresItens = new BehaviorSubject<SetorItensEscalaPeriodoColaborador[]>([]);
  setoresItens$ = this.setoresItens.asObservable();

  private alertarFecharSetoresBS = new BehaviorSubject<boolean>(false);
  alertarFecharSetores$ = this.alertarFecharSetoresBS.asObservable();

  constructor() { }

  update(courierData: Partial<EscalaPeriodo>) {
    const newCourier = {
      ...(this.courierSubject.value != null ? this.courierSubject.value : {}),
      ...courierData
    }
    if(newCourier.setorColaboradores) {
      const setores = newCourier.setorColaboradores?.sort((a, b) => {
        return a.setor.nome.localeCompare(b.setor.nome)
      })
      newCourier.setorColaboradores = setores;
    }

    this.courierSubject.next(newCourier as EscalaPeriodo);
    console.log(newCourier, 'ScaleInUseService updated')
  }

  updateEscalaPai(escalaPai: Escala | null) { this.escalaPai.next(escalaPai) }

  getObservable(): Observable<EscalaPeriodo | null> {
    return this.courier$;
  }

  getValues(): EscalaPeriodo | null {
    return this.courierSubject.value;
  }

  getEscalaPeriodoId(): number | null {
    if (this.courierSubject.value?.id) {
      return this.courierSubject.value.id
    }
    return null;
  }


  getEscalaId(): number | null {
    if (this.courierSubject.value?.id) {
      return this.courierSubject.value.escalaId
    }
    return null;
  }

  reset(): void {
    this.courierSubject.next(null)
  }

  set(escalaPeriodo: EscalaPeriodo): void {
    this.courierSubject.next(escalaPeriodo);
  }

  addSetor(setor: Setor): void {
    const data = this.setores.value;
    data.push(setor);
    this.setores.next(data);
  }

  updateSetor(setor: Setor): void {
    const data = this.setores.value;
    const index = data.findIndex(item => item.id === setor.id);
    if (index > -1) {
      data[index] = setor;
      this.setores.next(data);
    }
  }

  deleteSetor(setorId: number): void {
    const data = this.setores.value;
    const index = data.findIndex(item => item.id === setorId);
    if (index > -1) {
      data.splice(index, 1);
      this.setores.next(data);
    }

  }

  setSetores(setores: Setor[]): void {
    this.setores.next(setores);
  }

  getSetores(): Observable<Setor[]> {
    return this.setores$;
  }

  getTurnos(): Observable<Turno[]> {
    return this.turnos$;
  }

  addTurno(turno: Turno): void {
    const data = this.turnos.value;
    data.push(turno);
    this.turnos.next(data);
  }

  updateTurno(turno: Turno): void {
    const data = this.turnos.value;
    const index = data.findIndex(item => item.id === turno.id);
    if (index > -1) {
      data[index] = turno;
      this.turnos.next(data);
    }
  }

  deleteTurno(turnoId: number): void {
    const data = this.turnos.value;
    const index = data.findIndex(item => item.id === turnoId);
    if (index > -1) {
      data.splice(index, 1);
      this.turnos.next(data);
    }
  }

  setTurnos(turnos: Turno[]): void {
    this.turnos.next(turnos);
  }

  private getColors(items: any[]) {
    return items.map(c => c.cor);
  }

  getColorsSelected() {
    const cores = [...this.getColors(this.setores.value), ...this.getColors(this.turnos.value)];

    console.log(cores);
    return of(cores);
  }

  addSetorItens(setorItens: SetorItensEscalaPeriodoColaborador): void {
    const data = this.setoresItens.value;
    data.push(setorItens);
    this.setoresItens.next(data);
  }

  updateSetorItens(setorItens: SetorItensEscalaPeriodoColaborador): void {
    const data = this.setoresItens.value;
    const index = data.findIndex(item => item.setor.id === setorItens.setor.id);
    if (index > -1) {
      data[index] = setorItens;
      this.setoresItens.next(data);
    }
  }

  deleteSetorItens(setorId: number): void {
    const data = this.setoresItens.value;
    const index = data.findIndex(item => item.setor.id === setorId);
    if (index > -1) {
      data.splice(index, 1);
      this.setoresItens.next(data);
    }
  }

  deleteTurnoItens(turnoId: number) {
    const data = this.setoresItens.value;
    // const index = data.
    for(let setor = 0; setor < data.length; setor++) {
      for(let colbItens = 0; colbItens < data[setor].itens.length; colbItens++) {
        for(let itemColaborador = 0; itemColaborador < data[setor].itens[colbItens].itens.length; itemColaborador++) {
          const itemColab = data[setor].itens[colbItens].itens[itemColaborador];
          if(itemColab.turno.id == turnoId){
            console.log(turnoId, itemColab)
            data[setor].itens[colbItens].itens.splice(itemColaborador);
          }
        }
      }
    }
    this.setoresItens.next(data);
  }

  setSetoresItens(setoresItens: SetorItensEscalaPeriodoColaborador[]): void {
    this.setoresItens.next(setoresItens);
  }

  getSetoresItens(): Observable<SetorItensEscalaPeriodoColaborador[]> {
    return this.setoresItens$;
  }

  getSetorItensById(setorId: number): SetorItensEscalaPeriodoColaborador | undefined {
    return this.setoresItens.value.find(item => item.setor.id === setorId);
  }

  alertarFecharSetores() {
    this.alertarFecharSetoresBS.next(true);
  }
}
